import React from 'react';
import { Separator } from "./ui/separator";
const Footer = () => {
  return <footer className="bg-gray-50 pt-8 pb-6">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          
        </div>
        
        <Separator className="my-6" />
        
        <div className="flex flex-col md:flex-row justify-between items-center">
          <p className="text-rental-muted mb-4 md:mb-0">© 2025 Ty Gwennili. Tous droits réservés.</p>
          <div className="flex gap-6">
            
            
            
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;